import { OverlayShellConfig } from "../../shared/overlay-shell/overlay.models";

export const EMPLOYEE_LEFT_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
